const API_STRINGS = {
  APP_MANAGER: {
    GET_LIST: 'api/apps',
    EXPORT_LIST_APP: 'api/apps/export/csv',
    GET_APPS_SELECT: 'api/apps/brief-info',
    GET_DETAIL: 'api/apps',
    PUBLISH_APP: 'api/apps/publish',
    RE_PUBLISH_APP: 'api/apps/republish',
    UNPUBLISH_APP: 'api/apps/unpublish',
    CREATE_APP: 'api/apps',
    EDIT_APP: 'api/apps/edit',
    EDIT_APP_DESCRIPTION: (id) => `api/apps/edit/${id}/description`,
    EDIT_APP_GENERAL: (id) => `api/apps/edit/${id}/general`,
    EDIT_APP_CONFIG: (id) => `api/apps/edit/${id}/config`,
    GET_CATEGORIES: 'api/apps/app-categories',
    TOGGLE_SHOW_REVIEWS: 'api/AppManager/ToggleShowReviews',
    GET_BAU_MODULES: 'api/apps/mobile-bau-modules',
    GET_APP_PRICING: (id) => `api/apps/${id}/pricing`,
    UPSERT_APP_PRICING: (id) => `api/apps/${id}/pricing/upsert`,
    GET_APP_PERMISSIONS: 'api/apps/permissions',
    UPDATE_APP_PERMISSION: 'api/apps/permissions',
  },
  RATING_MANAGER: {
    GET_LIST: 'api/ratings',
    TOGGLE_COMMENT_VISIBILITY: (id) =>
      `api/ratings/${id}/ToggleCommentVisibility`,
  },
};

export default API_STRINGS;
